module.exports = __webpack_public_path__ + "img/mobile-menu-cashback.97013635.webp";